// material-ui
import { createTheme } from "@mui/material/styles";

// third-party
import { presetPalettes } from "@ant-design/colors";

// project import
import ThemeOption from "./theme";
import { adjustColor } from "utils/adjustColor";

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  const colors = presetPalettes;

  let greyPrimary = [
    "#ffffff",
    "#fafafa",
    "#f5f5f5",
    "#f0f0f0",
    "#d9d9d9",
    "#bfbfbf",
    "#8c8c8c",
    "#595959",
    "#262626",
    "#141414",
    "#000000",
  ];
  let greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
  let greyConstant = ["#fafafb", "#e6ebf1"];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff",
        iconColor: "#101828",
        border: "#DBDEE0",
      },
      ...paletteColor,
      error: {
        ...paletteColor.error,
        dark: "#BC1B06",
        darker: '#912018',
        lighter: '#FEF3F2',
        light: '#FECDCA',
      },
      success: {
        ...paletteColor.success,
        dark: "#039855",
      },
      primary: {
        ...paletteColor.primary,
        dark: "#101828",
        darker: '#101828',
        light: '#F2F4F7',
        lighter: '#F9FAFB',
      },
      text: {
        ...paletteColor.text,
        primary: "#101828",
        secondary: "#51555C",
        disabled: paletteColor.grey[500],
      },
      action: {
        ...paletteColor.action,
        disabled: paletteColor.grey[300],
      },
      status: {
        RESOLVED: {
          background: "#ECFDF3",
          color: "#027A48",
          // icon: "#12B76A",
          icon: adjustColor("#027A48", 45),
        },
        FALSE_ALARM: {
          background: "#FEF3F2",
          color: "#B42318",
          // icon: "#F04438",
          icon: adjustColor("#B42318", 45),
        },
        IN_PROGRESS: {
          background: "#EEF4FF",
          color: "#3538CD",
          // icon: "#6172F3",
          icon: adjustColor("#3538CD", 45),
        },
        VERIFICATION_PENDING: {
          background: "#F2F4F7",
          color: "#344054",
          icon: adjustColor("#344054", 45),
        },
        IN_VERIFICATION: {
          background: "#F2F4F7",
          color: "#344054",
          icon: adjustColor("#344054", 45),
        },

        normal: {
          background: "#F2F4F7",
          color: "#344054",
          icon: "#344054",
        },
        active: {
          background: "#ECFDF3",
          color: "#027A48",
          icon: "#12B76A",
        },
        inactive: {
          background: "#FEF3F2",
          color: "#B42318",
          icon: "#F04438",
        },
        deactivated: {
          background: "#FFFAEB",
          backgroundBorder: "#FFFAEB",
          iconBackground: "#FEF0C7",
          iconColor: "#DC6803",
          color: "#B54708",
          icon: "#F79009",
        },
        never_onboarded: {
          background: "#EEF4FF",
          color: "#3538CD",
          icon: "#6172F3",
        },
        role: {
          background: "#F2F4F7",
          color: "#344054",
          icon: "#6172F3",
        },
      },
      divider: "#DBDEE0",
      background: {
        paper: paletteColor.grey[0],
        grey: colors.grey,
        default: paletteColor.grey.A50,
      },
      blue: {
        100: "#DAECFF",
        200: "#80BFFF",
        400: "#3399FF",
        500: "#007FFF",
        600: "#0072E5",
        700: "#0059B2",
      },
      border: {
        input: "#DBDEE0",
      },
    },
  });
}
